export const blockIconsTransportationFlightNew = (
	<span className='material-symbols-outlined'>flight</span>
);
